import { Component, computed, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { faAnglesUpDown } from '@fortawesome/pro-regular-svg-icons';
import { Question } from '@empathy/survey-core';

@Component({
  selector: 'empathy-dropdown-question-view',
  templateUrl: 'dropdown-question-view.component.html',
  styleUrls: ['./dropdown-question-view.component.scss', './_dropdown-question-view-theme.component.scss']
})
export class DropdownQuestionViewComponent {
  question = input<Question>();
  questionGrp = input<FormGroup>();

  visibleOptions$ = computed(() => this.question().visibleOptions);

  faAnglesUpDown = faAnglesUpDown;
}
